export default "__VITE_ASSET__BNRkP7Wr__"